import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { Mailbox, mailboxApi } from "@/api/mailbox";

export interface MailboxState {
  mailboxes: Mailbox[];
  mailboxId: string;
  selectedMailboxOwner: string;
}

const mailboxModule: Module<MailboxState, RootState> = {
  namespaced: true,
  state: () => {
   return ({
      mailboxes: [] as Mailbox[],
      mailboxId: "",
      selectedMailboxOwner: "-99",
    } as MailboxState)
  },
  mutations: {
    setAllMailboxes(state: MailboxState, mailboxes: Mailbox[]): void {
      state.mailboxes = mailboxes;
      if (mailboxes && mailboxes.length > 0) {
        state.mailboxId = mailboxes[0].id ?? "";
      }
    },
    setSelectedMailboxOwner(state: MailboxState,selectedMailboxOwner: string): void {
      state.selectedMailboxOwner = selectedMailboxOwner;
    }
  },
  actions: {
    async loadAllMailboxesAsync(
      context: ActionContext<MailboxState, RootState>
    ): Promise<void> {
        context.commit("setAllMailboxes", await mailboxApi.list());
    },
    async addMailbox(
      context: ActionContext<MailboxState, RootState>,
      mailbox: Mailbox
    ): Promise<void> {
      mailbox.id = await mailboxApi.add(mailbox);
      context.commit("setAllMailboxes", await mailboxApi.list());
    },
    async editMailbox(
      context: ActionContext<MailboxState, RootState>,
      mailbox: Mailbox
    ): Promise<void> {
      if (mailbox.id) {
        await mailboxApi.edit(mailbox.id, mailbox);
        context.commit("setAllMailboxes", await mailboxApi.list());
      }
    },
    async removeMailbox(
      context: ActionContext<MailboxState, RootState>,
      mailbox: Mailbox
    ): Promise<void> {
      if (mailbox.id) {
        await mailboxApi.delete(mailbox.id);
        context.commit("setAllMailboxes", await mailboxApi.list());
      }
    },
  },
};

export default mailboxModule;
